import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ReactSession } from 'react-client-session';
import { useNavigate } from "react-router-dom";
ReactSession.setStoreType("localStorage");

const Login = () => {
    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const navigate = useNavigate();


     if(!ReactSession.get("welbeinguserId")){
      ReactSession.set("welbeinguserId","0");
    }
    else{
      ReactSession.set("welbeinguserId", ReactSession.get("welbeinguserId"));
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            const response = await fetch('https://api.welbeing.in/login/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                    password: formData.password
                })
            });

            const data = await response.json();

            if (data.status === 'success') {
                //console.log('Login successful:', data.data);
               ReactSession.set("welbeinguserId", data.data.cust_id);
               ReactSession.set("welbeinguserName", data.data.name);
               ReactSession.set("welbeingemail", data.data.email);
               ReactSession.set("welbeingphonenumber", data.data.phonenumber);
               ReactSession.set("welbeinggender", data.data.gender);
               ReactSession.set("welbeingprofile", data.data.profile);
              
      
                alert(`Welcome ${data?.data?.name}`);
                navigate('/accounts');
        }else{
          //console.log(response.data.error.message);
          ReactSession.set("welbeinguserId", "0");
          const errors ='Username or Password Not Registered! Contact Your administrator.'
          setMessage(errors);
        }
  
        setError(validate(data));
        
        } catch (error) {
          //console.error('Login failed!', error);
          ReactSession.set("welbeinguserId", "0");
        }
  
    }

    const validate=(response)=>{
        const errors={};
          if(response.data.error){
            errors.name = response.data.error.message;
          }
          return errors;
      }
    
      useEffect(()=>{
        //console.log(error);
        if(Object.keys(error).length ===0 & formData){
          
          //console.log(input);
        }
       
      });

    return (
        <>
            <Header />
            <div className="main" style={{marginTop:'130px'}}>
                <section className="page-body p-0">
                    <div className="row g-0 ratio_asos">
                        <div className="order-2 order-lg-1 col-lg-5">
                            <div className="content-box">
                                <form onSubmit={handleSubmit} className="custom-form form-pill">
                                    <div>
                                        <h5>LOGIN <span className="bg-theme-blue"></span></h5>

                                        {error && (
                                            <div className="alert alert-danger">{error}</div>
                                        )}

                                        <div className="input-box">
                                            <label htmlFor="email">Email</label>
                                            <input 
                                                className="form-control" 
                                                type="email" 
                                                name="email" 
                                                id="email" 
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="input-box">
                                            <label htmlFor="password">Password</label>
                                            <div className="icon-input">
                                                <input 
                                                    className="form-control" 
                                                    type="password" 
                                                    name="password" 
                                                    id="password" 
                                                    value={formData.password}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        {message && message.length > 0 && (
                                              <p className="text-danger">{message}</p>
                                            )}

                                        <button 
                                            type="submit" 
                                            className="btn-solid rounded-pill line-none"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? 'Signing in...' : 'Signin'} <i className="arrow"></i>
                                        </button>
                                        <a href="/" className="btn-solid rounded-pill line-none btn-outline mt-3 d-flex justify-content-center">
                                            Home <i className="arrow"></i>
                                        </a>
                                    
                                        <span className="backto-link font-default content-color text-decoration-none">
                                            If you are new, <a className="text-decoration-underline theme-color" href="/register"> CREATE AN ACCOUNT NOW </a>
                                        </span>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="order-1 order-lg-2 col-lg-7 mt-5">
                            <div className="img-box">
                                <img className="img-fluid" src="/assets/img/banner/login.png" alt="banner" width={700} />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default Login;